// Close the dropdown menu if the user clicks outside of it
window.onclick = function (event) {
  if (!event.target.matches(".dropdown")) {
    hideDropdowns();
  }
};

function hideDropdowns() {
  let dropdowns = document.getElementsByClassName("dropdown-content");
  let i;
  for (i = 0; i < dropdowns.length; i++) {
    let openDropdown = dropdowns[i];
    if (openDropdown.classList.contains("show")) {
      openDropdown.classList.remove("show");
    }
  }
}

function shadeColor(color, percent) {
  var R = parseInt(color.substring(1, 3), 16);
  var G = parseInt(color.substring(3, 5), 16);
  var B = parseInt(color.substring(5, 7), 16);

  R = parseInt((R * (100 + percent)) / 100);
  G = parseInt((G * (100 + percent)) / 100);
  B = parseInt((B * (100 + percent)) / 100);

  R = R < 255 ? R : 255;
  G = G < 255 ? G : 255;
  B = B < 255 ? B : 255;

  var RR = R.toString(16).length == 1 ? "0" + R.toString(16) : R.toString(16);
  var GG = G.toString(16).length == 1 ? "0" + G.toString(16) : G.toString(16);
  var BB = B.toString(16).length == 1 ? "0" + B.toString(16) : B.toString(16);

  return "#" + RR + GG + BB;
}

function getAutoDate(autoDate = "Sunday") {
  if (autoDate === "Off") {
    return null; // auto date is turned off
  }

  // calculate the date
  let dayNames = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ];
  let autoDay = dayNames.indexOf(autoDate);
  let date = new Date();
  let today = date.getDay();
  let offset = today <= autoDay ? autoDay - today : autoDay + 7 - today;
  let dayOfMonth = date.getDate() + offset;
  date.setDate(dayOfMonth);
  return date;
}

function setStyleCSS(css, id) {
  let style = document.getElementById(id);

  if (!style) {
    // style doesn't exist, create new style
    style = document.createElement('style');
    style.id = id;
    document.head.append(style);
    style.innerHTML = css;
    return;
  }

  if (style.innerHTML !== css) {
    // don't update style unless it has changed
    style.innerHTML = css;
  }
}

export { shadeColor, hideDropdowns, getAutoDate, setStyleCSS };
